import React, { useEffect } from 'react';
import './CancelledMessage.css';

export default function CancelledMessage() {
  useEffect(() => {
  const alert = document.querySelector('.weather-alert');

  if (!alert) return;

  const updateHeight = () => {
    const height = alert.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--message-height', `${height}px`);
  };

  updateHeight();

  window.addEventListener('resize', updateHeight);

  return () => {
    window.removeEventListener('resize', updateHeight);
    document.documentElement.style.setProperty('--message-height', '0px');
  };
}, []);

  return (
    <div className="weather-alert" role="status" aria-live="polite" aria-label="Weather notice">
      <div className="weather-alert-inner">
        <div className="weather-icon" aria-hidden="true">
          {/* simple sun + cloud SVG */}
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
            <path
                d="M12 2L1 21h22L12 2z"
                fill="#FFC107"
                stroke="#F57C00"
                stroke-width="1.5"
                stroke-linejoin="round"
            />
            <path
                d="M12 8v6"
                stroke="#05202a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <circle
                cx="12"
                cy="17"
                r="1"
                fill="#05202a"
            />
            </svg>
        </div>

        <div className="weather-text">
          <span className="lead"><strong>Alert:</strong></span>
          <span className="message">
            {/* {' '}The Melville Coin Show <strong>WILL BE HELD</strong> on Sunday, December 28th, despite inclement weather. */}
            {' '}The Melville Coin Show scheduled for this coming Sunday, September 13th, has been canceled. Please check back here for any updates.
          </span>
        </div>
      </div>
    </div>
  );
}